<script lang="ts" setup generic="T">

const props = defineProps<{ items: T[] }>()

const [index] = defineModel<number>({ required: true })

const list = [...props.items]
list.push(...list)

const _index = ref(index.value)

const stop = ref(false)

watch(_index, (v) => {
  stop.value || animate()
  if (v >= props.items.length) {
    setTimeout(() => {
      stop.value = true
      _index.value = v % props.items.length
      setTimeout(() => {
        stop.value = false
      }, 1000 / 30)
    }, duration)
  } else {
    index.value = _index.value
  }
})

const el = shallowRef<HTMLElement>()

const elTitles = shallowReactive<HTMLElement[]>([])

const width = ref(0)

// const offsetTitle = computed(() => {
//   return -elTitles[index.value]?.offsetLeft
// })


// 
const offset = computed(() => {
  const offset = -width.value * _index.value
  const r = isSwiping.value ? offset - flexFn(lengthX.value) : offset
  // console.log(a)
  return r
})

// 给偏移量加个弹性值
const flexFn = (x: number) => {
  let n = Math.abs(x)
  const y = (-1 + Math.sqrt(1 + Math.max(n / 4, width.value / 20) * Math.abs(n))) / 1.4
  return x > 0 ? y : -y
}

const { direction, isSwiping, lengthX } = useSwipe(el, {
  threshold: 20,
  passive: false,
  onSwipeEnd() {
    animate()
    const delta = flexFn(lengthX.value)
    // console.log(delta)
    if (Math.abs(delta) > width.value / 10) {
      let next = _index.value
      const range = _numInRange(0, list.length - 1)
      next = range(_index.value + (delta > 0 ? 1 : -1))
      requestAnimationFrame(() => {
        if (next !== _index.value) {
          _index.value = next
        }
      })
    }
  },
},)

const duration = 500

const startAnimate = ref(false)
const animate = () => {
  startAnimate.value = true
  setTimeout(() => {
    startAnimate.value = false
  }, duration)
}

// todo:自适应高度
const height = ref()

// 默认全屏宽度
onMounted(() => {
  width.value = window.innerWidth * 0.8
})
</script>

<template>
  <div class=" overflow-hidden flex flex-col" :style="{ '--swipe-duration': duration + 'ms' }">
    <!-- <div class=" w-full overflow-auto">
      <MRow class=" w-[9999px] ml-3 gap-8 font-[900] relative" :class="['transition-all ease-in-out delay-100']">
        <div v-for="(item, i) in items" :ref="e => { elTitles[i] = e as HTMLElement }" @click="index = i"
          :class="index === i ? 'text-[#000000E0]' : 'text-[#00000040]'">
          <slot name="title" v-bind="{ item }"></slot>
        </div>
      </MRow>
    </div> -->
    <MRow class=" w-[9999px] !items-start" ref="el" :class="[startAnimate && 'transition-all ease-in-out']"
      :style="{ transform: `translateX(${offset}px)` }">
      <div v-for="(item, i) in list" :style="{ width: width + 'px' }">
        <slot name="content" v-bind="{ item }"></slot>
      </div>
    </MRow>
  </div>
</template>

<style lang="scss" scoped>
.transition-all {
  transition-duration: var(--swipe-duration)
}
</style>
